import { Box, Stack, Typography } from "@mui/material";
import { times } from "lodash";

import { ProtocolEditRoute_GetByIdQuery } from "../../routes/ProtocolEditRoute/queries.generated";
import VisitLine from "./VisitLine";

type Protocol = NonNullable<ProtocolEditRoute_GetByIdQuery["protocolGetById"]>;

type Props = {
    protocol: Protocol;
    yearLength: number;
};

export default function PossibleVisitsForProtocol({ protocol, yearLength }: Props) {
    return (
        <Box key={protocol.id}>
            <Typography>{protocol.name}</Typography>
            <Stack direction="row" sx={{ pl: 3 }}>
                {times(12, num => (
                    <Typography key={num} variant="caption" textAlign="center" sx={{ flex: 1 }}>
                        {new Date(0, num).toLocaleString("nl-NL", {
                            month: "short",
                        })}
                    </Typography>
                ))}
            </Stack>
            {protocol.visits?.map(visit => (
                <VisitLine
                    key={visit.id}
                    visit={visit}
                    yearLength={yearLength}
                    possibleVisits={protocol.possibleVisitDays?.[visit.id]}
                />
            ))}
        </Box>
    );
}
